/* eslint-disable filenames/match-regex */

// KEY PAYLOAD TYPES
// This is used to used to update the state of the key you wish to update

export const KEY_RECOMMENDED_DEALS = 'recommendedDeals';
export const KEY_BUY_AGAIN_DEALS = 'buyAgainDeals';
export const KEY_NEW_PRODUCT_DEALS = 'newProductDeals';
export const KEY_RECENTLY_VIEWED_DEALS = 'recentlyViewedDeals';
